import { MY_LOADS_PAGINATION } from '../Constants/Constants';

export const getAllShipmentsRequestPayload = (
  driverId: string,
  slug: string,
  pageIndex: number,
) => {
  return {
    driverId,
    filter: {
      driverAssigned: 'DriverAssigned' === slug,
      inTransit: 'In-Transit' === slug,
      deliveredNeedsPaperWork: 'DeliveredNeedsPPWK' === slug,
      deliveredWithPaperWork: 'DeliveredWithPPWK' === slug,
      delivered: 'Delivered' === slug,
    },
    pagination: {
      pageSize: MY_LOADS_PAGINATION.PAGE_SIZE,
      pageIndex: pageIndex || 0,
    },
  };
};
